import { render, staticRenderFns } from "./r-trader-config-dialog.vue?vue&type=template&id=f42dda76&scoped=true"
import script from "./r-trader-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-trader-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-trader-config-dialog.vue?vue&type=style&index=0&id=f42dda76&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42dda76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f42dda76')) {
      api.createRecord('f42dda76', component.options)
    } else {
      api.reload('f42dda76', component.options)
    }
    module.hot.accept("./r-trader-config-dialog.vue?vue&type=template&id=f42dda76&scoped=true", function () {
      api.rerender('f42dda76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-config-dialog.vue"
export default component.exports